// src/utils/cache/changedSinceStore.ts
import { extractApiPath } from "src/utils/cache/idbUtility";
import { getCacheUserScope } from "src/utils/cache/idbUtility";

const PREFIX = "changed_since_";

const mem = new Map<string, string | null>();

function safeGetLS(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSetLS(key: string, value: string | null) {
  if (typeof window === "undefined") return;
  try {
    if (value == null || value === "") window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

function normalizeScopeKey(cacheKeyOrUrl: string) {
  const cacheKey = extractApiPath(cacheKeyOrUrl);
  const scope = getCacheUserScope() || "anon";
  return `${PREFIX}${scope}:${cacheKey}`;
}

export function getChangedSince(cacheKeyOrUrl: string): string | null {
  const scopedKey = normalizeScopeKey(cacheKeyOrUrl);
  if (mem.has(scopedKey)) return mem.get(scopedKey) ?? null;

  const v = safeGetLS(scopedKey);
  mem.set(scopedKey, v);
  return v;
}

export function setChangedSince(cacheKeyOrUrl: string, value: string | null) {
  const scopedKey = normalizeScopeKey(cacheKeyOrUrl);
  mem.set(scopedKey, value ?? null);
  safeSetLS(scopedKey, value ?? null);
}

export function clearChangedSince(cacheKeyOrUrl: string) {
  setChangedSince(cacheKeyOrUrl, null);
}

export function clearChangedSinceForKeys(keysToRemove: string[]) {
  if (typeof window === "undefined") return;
  if (!keysToRemove?.length) return;

  const scope = getCacheUserScope() || "anon";
  const seen = new Set<string>();

  try {
    for (const k of keysToRemove) {
      const path = extractApiPath(String(k));
      if (!path || seen.has(path)) continue;

      const scopedKey = `${PREFIX}${scope}:${path}`;
      window.localStorage.removeItem(scopedKey);
      mem.delete(scopedKey);
      seen.add(path);
    }
  } catch {
    // ignore
  }
}
